import { useState } from "react";

export default function useLeaveDateFilter({
  getEmployeeLeaveData,
  monthStart,
  monthEnd,
}) {
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [minDate, setMinDate] = useState(null);
  const [view, setView] = useState(false);

  const formatDate = (date) => {
    if (!date) return "";

    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${month}/${day}/${year}`;
  };

  const startDateOnChange = (date) => {
    setStartDate(date);
    setSelectedStartDate(date);
    setMinDate(date);
  };

  const endDateOnChange = (date) => {
    setEndDate(date);
    setSelectedEndDate(date);
  };

  const formattedStartDate = formatDate(selectedStartDate);
  const formattedEndDate = formatDate(selectedEndDate);

  const clearAllDates = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);

    getEmployeeLeaveData(monthStart, monthEnd);
  };

  const searchButtonClick = () => {
    getEmployeeLeaveData(formattedStartDate, formattedEndDate);
    setView(false);
  };

  return {
    startDate,
    endDate,
    selectedStartDate,
    selectedEndDate,
    minDate,
    view,
    setView,
    startDateOnChange,
    endDateOnChange,
    clearAllDates,
    searchButtonClick,
  };
}